// extracted by mini-css-extract-plugin
module.exports = {"container":"_inputswitch_container__2EhsF","inputLabel":"_inputswitch_inputLabel__1kSkd","input":"_inputswitch_input__DVvxt"};